import React, { useState, useEffect, useRef } from 'react';
import styles from './Chatbot.module.scss';
import { selectChatbot, sendMessage } from '../store/Chatbot.store';
import { useDispatch, useSelector } from 'react-redux';
import { ReactComponent as SendButton } from '../assets/svgs/send.svg';

const ChatFooter: React.FC = () => {
    const { messages, isLoading, sessionId } = useSelector(selectChatbot);
    const [newMessage, setNewMessage] = useState<string>('');
    const dispatch = useDispatch();
    const chatbotTextAreaRef = useRef<HTMLTextAreaElement>(null);

    useEffect(() => {
        if (!isLoading && chatbotTextAreaRef.current && (document.activeElement === document.body || document.activeElement === null)) {
            // Setze den Fokus zurück, wenn kein anderes Eingabefeld ausgewählt wurde
            chatbotTextAreaRef.current.focus();
        }
    }, [isLoading]);

    const handleKeyPress = (event: React.KeyboardEvent<HTMLTextAreaElement>) => {
        if (event.key === 'Enter' && !event.shiftKey) {
            event.preventDefault();
            handleSendMessage();
        } else if (event.key === 'Enter' && event.shiftKey) {
            event.preventDefault();
            setNewMessage((prev) => prev + '\n');
        }
    };

    const handleSendMessage = () => {
        if (newMessage.trim() !== '' && !!sessionId) {
            dispatch(sendMessage({ message: newMessage, messages: messages, sessionId: sessionId }));
            setNewMessage('');
        }
    };

    return (
        <div className={styles.chatFooter}>
            <div className={styles.inputAndButton}>
                <textarea
                    ref={chatbotTextAreaRef}
                    value={newMessage}
                    onChange={(e) => setNewMessage(e.target.value)}
                    onKeyDown={handleKeyPress}
                    placeholder="Nachricht eingeben..."
                    className={styles.textarea}
                    disabled={isLoading}
                />
                <button onClick={handleSendMessage} className={styles.sendButton} disabled={isLoading || newMessage.trim() === ''}>
                    <SendButton />
                </button>
            </div>
        </div>
    );
};

export default ChatFooter;
